var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTwoUsers = function SvgTwoUsers(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 44 44"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#two-users_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    x: 12,
    y: 10,
    fill: "#fff",
    rx: 10,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    x: 12.5,
    y: 10.5,
    stroke: "currentColor",
    strokeOpacity: 0.3,
    rx: 9.5,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M25 24.5a4 4 0 0 0-4-4m0 0a4 4 0 0 0-4 4m4-4a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5m6 3.5c0-1.685-1-3.25-2-4a2.5 2.5 0 0 0-.225-4.15"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "two-users_svg__a",
    x: 0,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    "in": "SourceAlpha",
    operator: "dilate",
    radius: 2,
    result: "effect1_dropShadow_3523_60500"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.478431 0 0 0 0 0.227451 0 0 0 0 1 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3523_60500"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_3523_60500",
    result: "shape"
  })))));
};
export default SvgTwoUsers;